var _rect, _rect2, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomin = function SvgZoomin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 21.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    x: 0.5,
    y: 0.5,
    stroke: "#D2D3D4",
    rx: 21.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "zoomin_svg__a",
    width: 24,
    height: 24,
    x: 10,
    y: 10,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M10 10h24v24H10z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#zoomin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D242B",
    d: "M18.844 20.054h-1.341a.6.6 0 0 1-.448-.181.61.61 0 0 1-.18-.45q0-.27.18-.447a.6.6 0 0 1 .448-.178h1.34v-1.324q0-.267.183-.448a.61.61 0 0 1 .45-.18q.267 0 .446.18.178.18.178.448v1.324h1.324q.268 0 .448.182.18.18.18.45 0 .267-.18.446a.61.61 0 0 1-.448.178H20.1v1.341q0 .267-.181.448a.61.61 0 0 1-.45.18.612.612 0 0 1-.625-.628zm.648 5.45q-2.551 0-4.32-1.767-1.768-1.767-1.768-4.296t1.767-4.297q1.767-1.77 4.3-1.769 2.533 0 4.3 1.767 1.77 1.768 1.769 4.298 0 1.057-.36 2.046a5.8 5.8 0 0 1-1.013 1.767l5.977 5.95q.18.174.186.447a.6.6 0 0 1-.186.462.63.63 0 0 1-.46.187.6.6 0 0 1-.452-.19l-5.96-5.961a5.4 5.4 0 0 1-1.735 1.002 6 6 0 0 1-2.044.354m-.01-1.256q2.01 0 3.406-1.399 1.395-1.4 1.395-3.41t-1.395-3.409-3.406-1.399q-2.018 0-3.42 1.4-1.401 1.398-1.402 3.409 0 2.01 1.402 3.409t3.42 1.399"
  }))));
};
export default SvgZoomin;